import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { SelectAndSearch } from "../../../ui/Form/SelectAndSearch";
import _Select from "../../../generic/_Select";
import _Button from "../../../generic/_Button";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../../Context/AuthContext";
import { useFormik } from "formik";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { DateFilters } from "../../../ui/Form/Period";
import { today } from "../../../../utils/dateHelpers";
const FiltersAdmin = (props) => {
  const {
    onRefresh,
    setPeriodStr,
    withStatusFilter = true,
    withPartnerFilter = true,
    withCarrierFilter = true,
    withShortCodeFilter = true,
    loading = false,
  } = props;
  const auth = useAuth();
  const userData = auth.getSessionData();
  const [reset, setReset] = useState(false);

  const formik = useFormik({
    initialValues: {
      idcarrier: "0",
      idshortcode: "0",
      idstatus: "0",
      dateFrom: "",
      idcustomer: "0",
      dateTo: "",
      idpartner: "0",
      period: {
        dateFrom: today("YYYY/MM/DD"),
        dateTo: today("YYYY/MM/DD"),
      },
    },
    onSubmit: (values) => {
      onRefresh({
        dateFrom: values.period.dateFrom,
        dateTo: values.period.dateTo,
        idcarrier: values.idcarrier,
        idshortcode: values.idshortcode,
        idcustomer: values.idcustomer,
        idpartner: values.idpartner,
      });
    },
  });

  useEffect(() => {
    setPeriodStr(
      `Del ${formik.values.period.dateFrom} al ${formik.values.period.dateTo}`,
    );
  }, [formik.values.period.dateFrom, formik.values.period.dateTo]);

  const { data: carriersList } = useQuery({
    queryKey: ["carriersList"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}carriers`,
        {},
        userData.token,
      );

      return response.data;
    },
    initialData: [],
    refetchOnWindowFocus: false,
    enabled: withCarrierFilter,
  });

  const { data: customersList } = useQuery({
    queryKey: ["customersList"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}customers`,
        {},
        userData.token,
      );

      return response.data;
    },
    initialData: [],
    refetchOnWindowFocus: false,
  });

  const { data: partnerList } = useQuery({
    queryKey: ["partnerList", formik.values.idcustomer],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}partners/${formik.values.idcustomer}`,
        {},
        userData.token,
      );

      console.log(response.data);

      return response.data;
    },
    initialData: [],
    refetchOnWindowFocus: false,
    enabled: withPartnerFilter && formik.values.idcustomer !== "0",
  });

  const { data: StatusList } = useQuery({
    queryKey: ["StatusList"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}configuration/smsStatus`,
        {},
        userData.token,
      );

      return response.data;
    },
    initialData: [],
    refetchOnWindowFocus: false,
    enabled: withStatusFilter,
  });

  const { data: shortCodesList } = useQuery({
    queryKey: ["shortCodesList"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}shortcodesbycarrier/${formik.values.idcarrier}`,
        {},
        userData.token,
      );

      return response.data;
    },
    initialData: [],
    refetchOnWindowFocus: false,
    enabled: withShortCodeFilter,
  });

  useEffect(() => {
    if (!formik.values.idcustomer) {
      formik.setFieldValue("idpartner", "0");
    }
  }, [formik.values.idcustomer]);

  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  return (
    <div className="w-full bg-white rounded-lg px-4 py-2">
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        <SelectAndSearch
          placeholder="Buscar Cliente"
          options={[
            {
              label: "Todos los clientes",
              value: "",
            },
            ...customersList.map((customer) => ({
              label: customer.name,
              value: customer.idcustomer,
            })),
          ]}
          values={formik.values.idcustomer}
          handleChange={(e) => {
            formik.setFieldValue("idcustomer", e);
          }}
          title="Cliente"
          onReset={reset}
        />
        {withPartnerFilter && (
          <_Select
            title="Partner"
            id="idpartner"
            value={formik.values.idpartner}
            onChange={(e) => formik.setFieldValue("idpartner", e.target.value)}
            options={[
              {
                label: "Todos los partners",
                value: "0",
              },
              ...partnerList.map((partner) => ({
                label: partner.name,
                value: partner.idpartner,
              })),
            ]}
          />
        )}
        {withCarrierFilter && (
          <_Select
            title="Carrier"
            id="idcarrier"
            onChange={(e) => formik.setFieldValue("idcarrier", e.target.value)}
            value={formik.values.idcarrier}
            options={[
              {
                label: "Todos los carriers",
                value: "0",
              },
              ...carriersList.map((item) => ({
                label: item.carrier,
                value: item.idcarrier,
              })),
            ]}
          />
        )}
        {withShortCodeFilter && (
          <_Select
            title="Número corto"
            id="idshortcode"
            value={formik.values.idshortcode}
            onChange={(e) =>
              formik.setFieldValue("idshortcode", e.target.value)
            }
            options={[
              {
                label: "Todos",
                value: "",
              },
              ...shortCodesList.map((item) => ({
                label: item.shortcode,
                value: item.idshortcode,
              })),
            ]}
          />
        )}
        {withStatusFilter && (
          <_Select
            title="Estatus"
            id="idstatus"
            value={formik.values.idstatus}
            onChange={(e) => formik.setFieldValue("idstatus", e.target.value)}
            options={[
              {
                label: "Todos",
                value: "0",
              },
              ...StatusList.map((item) => ({
                label: item.status,
                value: item.idstatus,
              })),
            ]}
          />
        )}

        <DateFilters
          setFilterFrom={(e) => formik.setFieldValue("period.dateFrom", e)}
          setFilterTo={(e) => formik.setFieldValue("period.dateTo", e)}
          errors={formik.errors}
          isClean={formik.values.period.dateFrom === ""}
        />
      </div>

      <div className="flex sm:grid-cols-1 grid-cols-2 gap-2">
        <_Button
          onClick={() => {
            setReset(true);
            formik.resetForm();
          }}
          loading={loading}
          style="none"
          title="Limpiar filtros"
          icon="refresh"
          className="w-full"
        />
        <_Button
          onClick={() => {
            formik.submitForm();
          }}
          loading={loading}
          style="primary"
          title="Consultar"
          className="w-full"
        />
      </div>
    </div>
  );
};

FiltersAdmin.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  withStatusFilter: PropTypes.bool,
  withPartnerFilter: PropTypes.bool,
  withCarrierFilter: PropTypes.bool,
  withShortCodeFilter: PropTypes.bool,
  setPeriodStr: PropTypes.func.isRequired,
};

export default FiltersAdmin;
